module.exports = __webpack_public_path__ + "static/media/luckyDraw.f94f3b8e.png";